import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const updateProgram = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ORGANIZE.UPDATE_PROGRAM,
    data
  );
};

export default updateProgram;
